import { REGISTRY } from "@bloglovin/inspire-engine/DynamicComponents/Helpers/inline-layout-registry-catalog.js";

// Maps an app's engine option keys (kebab) to the engine component's props through the engine's own registry,
// so a DCE wrapper stays in step with the engine; a key the engine does not know is logged, never guessed.
export function engineWiringProps(engineType, wiring, owner) {
  const optionToProp = REGISTRY[engineType]?.optionToProp ?? {};
  const props = {};
  Object.entries(wiring && typeof wiring === "object" ? wiring : {}).forEach(([key, value]) => {
    const prop = optionToProp[key];
    if (!prop) {
      // eslint-disable-next-line no-console
      console.error(`${owner}: wiring key "${key}" is not a ${engineType} option in this engine, so it is ignored`, {
        known: Object.keys(optionToProp),
      });
      return;
    }
    props[prop] = value;
  });
  return props;
}
